import React from 'react'

import { useTranslation } from 'react-i18next'

import { ColorTypeText } from '../components/types'

interface PrivacyProps {
    textColor: ColorTypeText
}

export const Privacy: React.FC<PrivacyProps> = ({ textColor }) => {
    const { t } = useTranslation()

    return (
        <div className="w-full flex flex-col mx-auto my-10 justify-center items-center">
            <div className={`max-w-container-s min-h-[2500px] h-auto flex flex-col justify-between mx-5 ${textColor}`}>
                <div className="text-4xl font-bold">{t('privacy.title')}</div>
                <br></br>
                <div>{t('privacy.controller')}</div>
                <div>
                    {t('imprint.name')} <br></br>
                    {t('imprint.address.street')} <br></br>
                    {t('imprint.address.city')}
                </div>
                <div>
                    {t('imprint.contact.phone')} <br></br>
                    {t('imprint.contact.fax')} <br></br>
                    {t('imprint.contact.email')}
                </div>
                <br></br>
                <div className="font-bold">{t('privacy.generalInfo.title')}</div>
                <div>{t('privacy.generalInfo.content1')}</div>
                <div>{t('privacy.generalInfo.content2')}</div>
                <div>{t('privacy.generalInfo.content3')}</div>
                <div>{t('privacy.generalInfo.content4')}</div>
                <br></br>
                <p className="font-bold">{t('privacy.websiteProvision.title')}</p>
                <div>{t('privacy.websiteProvision.content1')}</div>
                <ol className="list-decimal pl-10">
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                        <li key={item}>{t(`privacy.websiteProvision.list.item${item}`)}</li>
                    ))}
                </ol>
                <div>{t('privacy.websiteProvision.content2')}</div>
                <div>{t('privacy.websiteProvision.content3')}</div>
                <div>{t('privacy.websiteProvision.content4')}</div>
                <div>{t('privacy.websiteProvision.content5')}</div>
                <div>{t('privacy.websiteProvision.content6')}</div>
                <div>{t('privacy.websiteProvision.content7')}</div>
                <div>{t('privacy.websiteProvision.content8')}</div>
                <br></br>
                <p className="font-bold">{t('privacy.cookies.title')}</p>
                <div>{t('privacy.cookies.content1')}</div>
                <div>{t('privacy.cookies.content2')}</div>
                <div>{t('privacy.cookies.content3')}</div>
                <ul className="pl-10 list-disc">
                    {[1, 2].map((item) => (
                        <li key={item}>{t(`privacy.cookies.list.item${item}`)}</li>
                    ))}
                </ul>
                <div>{t('privacy.cookies.content4')}</div>
                <div>{t('privacy.cookies.content5')}</div>
                <div>{t('privacy.cookies.content6')}</div>
                <div>{t('privacy.cookies.content7')}</div>
                <div>{t('privacy.cookies.content8')}</div>
                <div>{t('privacy.cookies.content9')}</div>
                <div>{t('privacy.cookies.content10')}</div>
                <br></br>
                <p className="font-bold">{t('privacy.withdrawal.title')}</p>
                <div>{t('privacy.withdrawal.content')}</div>
                <ol className="list-decimal pl-10">
                    {[1, 2].map((item) => (
                        <li key={item}>{t(`privacy.deletion.list.item${item}`)}</li>
                    ))}
                </ol>
            </div>
        </div>
    )
}
